import { render, staticRenderFns } from "./ManageDiscounts.vue?vue&type=template&id=9c0b3570&"
import script from "./ManageDiscounts.vue?vue&type=script&lang=js&"
export * from "./ManageDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports